const autoNgTemplateLoaderTemplate1 = require('./node.html');

angular.module('portainer.kubernetes').component('kubernetesNodeView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesNodeController',
  controllerAs: 'ctrl',
  bindings: {
    endpoint: '<',
    $transition$: '<',
  },
});
